<template>
  <div class="item-inner">
    <div class="item-title label" v-if="attribute.sorteditAble === false" style="width: 60%; color: #8e8e93;" >{{this.attribute.label}}</div>
    <div class="item-title label" v-else style="width: 60%;">
      {{this.attribute.label}}
      <a class="alert-text" @click="displayMessage(attribute.description)" v-if="attribute.description">
        <img :src="questionUrl" style="width: .9rem"></img>
      </a>
    </div>
    <div class="item-input">
      <input type="text"  placeholder="请选择"  v-if="attribute.sorteditAble === false"  :value='attribute.value' disabled="disabled" >
      <input type="text"  @click="showOptionList(attribute)" placeholder="请选择"   v-else   v-model="attribute.valueText" readonly="readonly">
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Emkt from '../../emkt'
  import {mapState} from 'vuex'
  export default {
    name: 'attr-text-box',
    data () {
      return {
        checkedData: '',
        questionUrl: '/emktResources/resocurces/img/question.png',
        blood: Emkt.getLocalStorage('BloodOptionsChoose')
      }
    },
    props: [
      'attribute', 'index', 'curAttrsInGroup', 'attrGroups'
    ],
    mounted () {
    },
    created () {
      this.fetchData()
    },
    computed: {
      ...mapState([
        'hardGeneInfo'
      ]),
      options () {
        let opt = this.attribute.options
        let resArr = []
        if (opt) {
          for (var data in opt) {
            resArr.push(parseInt(data))
          }
          return resArr
        }
        return resArr
      }
    },
    methods: {
      getAfterText (attribute) {
        var ret1 = '<li class="item-content item-link"><label class="label-checkbox item-content">' +
          '<input type="radio" class="radio-input-attr" name="attr" value="'
        var ret2 = ''
        var ret3 = '"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">'
        var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">'
        let attr = this.attribute.options
        let height = ''
        var length = 0
        let tips = ''
        let BloodMaps = Emkt.getLocalStorage('BloodMaps')
        for (var key in attr) {
          if(attribute.columnName === 'AAVBloodType') {
            tips = BloodMaps[attr[key]] && `<div class="blood-tips" style="font-size: 12px">${BloodMaps[attr[key]]}</div>` || ''
          }
          if (attribute.valueText === attr[key]) {
            ret2 += ret1 + key + ret4 + attr[key] + + tips +'</div></div></label></li>'
          } else {
            ret2 += ret1 + key + ret3 + attr[key] + tips+ '</div></div></label></li>'
          }
          length++
        }
        var ret
        if (length <= 7) {
          height = 2.1 * length + 1
          ret = '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        } else {
          ret = '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        }
        ret = ret + ret2 + '</ul></div></div>'
        return ret
      },
      fetchData () {
        console.log(this.attribute)
        if ((this.attribute.columnName === 'CustRemark_Required' && this.attribute.value === '1') || (this.attribute.columnName === 'CustTlnoRemark_Required' && this.attribute.value === '1')) {
          this.curAttrsInGroup[24].isNA = false
        }
      },
      displayMessage (val) {
        if (!val) {
          return
        }
        $.alert(val)
      },
      getTitle (attribute) {
        return attribute.label
      },
      showOptionList (attribute) {
        let _this = this
        var chooseText =  _this.getAfterText(attribute)
        if(this.attribute.label  === "病毒滴度要求"){
           chooseText += "<div style='font-size:8px'>1E13不可选血清2、6 </div>"
        }
        $.modal({
          title: _this.getTitle(attribute),
          afterText: chooseText,
          buttons: [
            {
              text: '取消',
              bold: true,
              onClick: function () {
                if (_this.checkedData) {
                  _this.attribute.value = _this.checkedData
                }
              }
            }
          ]
        })
        $('.radio-input-attr').on('click', function () {
          let val
          let radio = $('.radio-input-attr')
          for (var i = 0; i < radio.length; i++) {
            if (radio[i].checked) {
              val = radio[i].value
            }
          }
          if (_this.attribute.value !== val) {
            _this.attribute.value = val
            _this.checkedData = val
            _this.valueChanged(attribute)
          }
          // 来源选择=非前合同，清空前合同的载体号
          if (_this.attribute.columnName === 'Source' && (['1', '2'].includes(_this.attribute.value))) {
            Emkt.setLocalStorage('TLNo', null)
          }
          if (_this.curAttrsInGroup && _this.curAttrsInGroup.length === 26 && _this.index <= 4) {
            Emkt.setLocalStorage('TLNo', null)
          }
          if (_this.attrGroups[0].attrs[2].value === '4') {
            _this.attrGroups[2].attrs[2].options = _this.blood
            _this.attrGroups[2].attrs[2].isNA = false
          }
          if (_this.attribute.columnName === 'Type' && (_this.curAttrsInGroup[6].value.category === 3) && (_this.curAttrsInGroup[6].value.ttttflag !== undefined && _this.curAttrsInGroup[6].value.ttttflag === 1)) {
            alert('microRNA序列中存在连续4个T，需要更换海绵体方法进行构建，不可以继续进行下一步选择，详细邮件询问售前技术支持。')
          }
          if (_this.attribute.columnName === 'Tech' && _this.attribute.value === '1') {
              // 慢病毒>6000 || 腺病毒>6500 || 逆转录>4000 ||悬浮病毒6000 || 质粒>10000
            if ((_this.curAttrsInGroup[2].value === Emkt.TOOLTYPE_LENTIVIRUS && _this.curAttrsInGroup[6].value.CDSSize > 6000) ||
                (_this.curAttrsInGroup[2].value === Emkt.TOOLTYPE_PLASMID && _this.curAttrsInGroup[6].value.CDSSize > 10000) ||
                (_this.curAttrsInGroup[2].value === Emkt.TOOLTYPE_ADENOVIRUS && _this.curAttrsInGroup[6].value.CDSSize > 6500) ||
                (_this.curAttrsInGroup[2].value === Emkt.TOOLTYPE_RETROVIRUS && _this.curAttrsInGroup[6].value.CDSSize > 4000) ||
                (_this.curAttrsInGroup[2].value === Emkt.TOOLTYPE_FLOATVIRUS && _this.curAttrsInGroup[6].value.CDSSize > 6000)
            ) {
              _this.$weui.alert('您所选择的基因，超出该合同类型的构建或包装极限，公司无法接入，请咨询售前如何实现客户需求，无法加入购物车，或重新选择基因')
            }
          }
          if (_this.hardGeneInfo && _this.hardGeneInfo.length > 0 && _this.attribute.sortOrder > 70) {//选完调控技术后开始判断拦截
            let hardHeneGo = true
            let hardGenecontent = {}
            for (let hardGene of _this.hardGeneInfo) {
              if(hardGene.level === Emkt.HardGeneLevelNo1) { // 合同大类检查调控技术 和靶点设计方案
                if(hardGene.contractType !== undefined && hardGene.contractType) {
                  //有hardGene
                  if (_this.curAttrsInGroup[12].value && hardGene.tech.includes(_this.curAttrsInGroup[12].value )) {
                    if (hardGene.targetSupplier !== undefined && hardGene.targetSupplier) {
                        if (_this.curAttrsInGroup[13].value  && hardGene.targetSupplier.includes(_this.curAttrsInGroup[13].value)) {
                          hardGenecontent = hardGene
                          hardHeneGo = false
                        }
                    } else {
                      hardHeneGo = false
                      hardGenecontent = hardGene
                      break
                    }
                  }
                  // if(_this.attribute.columnName === 'TemplateSource') {
                  //   //有hardGene
                  //   if (_this.curAttrsInGroup[12].value && hardGene.tech.includes(_this.curAttrsInGroup[12].value )) {
                  //     if (hardGene.targetSupplier !== undefined && hardGene.targetSupplier) {
                  //       if (_this.curAttrsInGroup[13].value  && hardGene.targetSupplier.includes(_this.curAttrsInGroup[13].value)) {
                  //         hardHeneGo = false
                  //       }
                  //     } else {
                  //       hardHeneGo = false
                  //     }
                  //   }
                  // }
                }
              }
            }
            if(!hardHeneGo) {
              _this.$weui.alert(hardGenecontent.infeasibilityStatement + '，'+ hardGenecontent.solution)
            }
          }
          if (_this.attribute.columnName === 'CustTlnoRemark_Required' && _this.attribute.value === '0') {
            alert('请告知由客户寄送实物，或者来源于客户其他合同号')
          }
          if ((_this.attribute.columnName === 'CustRemark_Required' && _this.attribute.value === '1') || (_this.attribute.columnName === 'CustTlnoRemark_Required' && _this.attribute.value === '1')) {
            _this.curAttrsInGroup[24].isNA = false
          }
          if ((_this.attribute.columnName === 'CustRemark_Required' && _this.attribute.value === '0') || (_this.attribute.columnName === 'CustTlnoRemark_Required' && _this.attribute.value === '0')) {
            _this.curAttrsInGroup[24].isNA = true
          }
          console.log('attrGroups', _this.attrGroups)
          //工具类型为腺相关病毒
          if(_this.attrGroups[0].attrs[26].value === Emkt.VIRUSTITER1E13 && _this.attribute.columnName === 'AAVBloodType' && ( _this.attribute.value === Emkt.AAVBLOODTYPESIX || _this.attribute.value === Emkt.AAVBLOODTYPETWO)){
            _this.$weui.alert("该血清型无法做到1E13的滴度，请重新按要求选择")
            _this.attribute.value = '-1'
          }
          //DR20231019001
          // if(_this.attrGroups[0].attrs[26].value === Emkt.VIRUSTITER5E12 && _this.attribute.columnName === 'AAVBloodType'){
          //   if(!( _this.attribute.value === Emkt.AAVBLOODTYPESIX || _this.attribute.value === Emkt.AAVBLOODTYPETWO) && _this.attribute.value != '-1'){
          //     _this.$weui.alert("5E12的滴度只允许选择2、6血清型，请重新按要求选择")
          //   _this.attribute.value = '-1'
          //   }
          // }
          const VIRUSTITER1E12 = '3' // 病毒滴度为1E12
          const LVAMOUNT1E12 = '25'  // 目的病毒总量为1E12
          const LVAMOUNT5E12 = '26'  // 目的病毒总量为5E12
          const LVAMOUNT1E11 = '23'  // 目的病毒总量为5E12
          const LVAMOUNT5E11 = '24'  // 目的病毒总量为5E12
          if(_this.attrGroups[0].attrs[26].value === VIRUSTITER1E12 && _this.attribute.columnName === 'LVAmount'){
            if(![LVAMOUNT1E12,LVAMOUNT5E12,LVAMOUNT1E11,LVAMOUNT5E11].includes(_this.attribute.value)){
              _this.$weui.alert("1E12的滴度只能选择1E12、5E12、1E11、5E11的目的病毒总量，请重新按要求选择")
              _this.attribute.value = '-1'
            }
          }
          if(_this.attribute.columnName === 'LVAmount'&&([LVAMOUNT1E11, LVAMOUNT5E11].includes(_this.attribute.value))){
            if(_this.attrGroups[0].attrs[26].value !== VIRUSTITER1E12) {
              _this.$weui.alert("1E11、5E11的目的病毒总量只能选择1E12的滴度，请重新按要求选择")
              _this.attribute.value = '-1'
            }
          }
          const CONTRACTTYPENC = '2' // 合同类型为对照产品
          const NCLVAMOUNTNONE = '6' // 无需对照
          const NCLVAMOUNT1E12 = '25'  // 对照病毒总量为1E12
          const NCLVAMOUNT5E12 = '26'  // 对照病毒总量为5E12
          if(_this.attrGroups[0].attrs[26].value === VIRUSTITER1E12 && _this.attribute.columnName === 'NC_LV_Amount'){
            if(![NCLVAMOUNT1E12,NCLVAMOUNT5E12, NCLVAMOUNTNONE,LVAMOUNT1E11,LVAMOUNT5E11].includes(_this.attribute.value)){
              _this.$weui.alert("1E12的滴度只能选择无需对照、1E12、5E12、1E11、5E11的对照病毒总量，请重新按要求选择")
              _this.attribute.value = '-1'
            }
          }
          if (_this.attrGroups[0].attrs[0].value === Emkt.AMPLIFICATION && _this.attribute.columnName === 'Source' && _this.attribute.value === Emkt.CUSTOMERPROVIDED){
            _this.$weui.alert("客户提供质粒用于病毒包装，公司不承诺滴度及出毒总量，仅提供实际出毒，请知悉风险")
          }
          if (_this.attribute.columnName === 'ContractType' && (_this.curAttrsInGroup[0].value === '3' || _this.curAttrsInGroup[0].value === '4')) {
            _this.gcapi('searchContractNo', null).then(function (response) {
              Emkt.setLocalStorage('contractNO', null)
              Emkt.setLocalStorage('target', null)
              Emkt.setLocalStorage('contractNO', response.body.result)
            })
          } else if (_this.attribute.columnName === 'ContractType' && (_this.curAttrsInGroup[0].value !== '3' || _this.curAttrsInGroup[0].value !== '4')) {
            Emkt.setLocalStorage('TLNo', null)
          }
          if (_this.attribute.columnName === 'ToolType' && _this.curAttrsInGroup[0].value === '3') {
            var newContractNos = []
            setTimeout(function () {
            }, 2000)
            let contractNos = Emkt.getLocalStorage('contractNO')
//            console.log(contractNos)
            if (contractNos) {
              if (_this.attribute.value === '3') {
                newContractNos = []
                for (var no1 in contractNos) {
                  if ((contractNos[no1].split(':')[0].indexOf('A') !== -1 || contractNos[no1].split(':')[0].indexOf('GCI') !== -1) && contractNos[no1].split(':')[0].indexOf('GVAP') === -1) {
                    newContractNos.push(contractNos[no1])
                  }
                }
                Emkt.setLocalStorage('newContractNos', null)
                Emkt.setLocalStorage('newContractNos', newContractNos)
//                _this.gcapi('searchPreContract', 'GIDL0119920').then(function (response) {
//                  if (response.body.result.labelNames !== undefined) {
//                    Emkt.setLocalStorage('target', response.body.result.labelNames)
//                  }
//                })
              } else if (_this.attribute.value === '4') {
                newContractNos = []
                for (var no in contractNos) {
                  if ((contractNos[no].split(':')[0].indexOf('V') !== -1 || contractNos[no].split(':')[0].indexOf('GCI') !== -1) && contractNos[no].split(':')[0].indexOf('GVAP') === -1) {
                    newContractNos.push(contractNos[no])
                  }
                }
                Emkt.setLocalStorage('newContractNos', null)
                Emkt.setLocalStorage('newContractNos', newContractNos)
              } else if (_this.attribute.value === '2') {
                newContractNos = []
                for (var no4 in contractNos) {
                  if (contractNos[no4].indexOf('病毒') !== -1 || contractNos[no4].indexOf('质粒') !== -1 || contractNos[no4].indexOf('shRNA') !== -1 || contractNos[no4].split(':')[0].indexOf('GCI') !== -1) {
                    newContractNos.push(contractNos[no4])
                  }
                }
                Emkt.setLocalStorage('newContractNos', null)
                Emkt.setLocalStorage('newContractNos', newContractNos)
              } else if (_this.attribute.value === '1') {
                newContractNos = []
                for (var no2 in contractNos) {
                  if (contractNos[no2].split(':')[0].indexOf('L') !== -1 || contractNos[no2].split(':')[0].indexOf('GCI') !== -1) {
                    newContractNos.push(contractNos[no2])
                  }
                }
                Emkt.setLocalStorage('newContractNos', null)
                Emkt.setLocalStorage('newContractNos', newContractNos)
//                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
//                  if (response.body.result.labelNames !== undefined) {
//                    Emkt.setLocalStorage('target', response.body.result.labelNames)
//                  }
//                })
              } else if (_this.attribute.value === '6') {
                newContractNos = []
                for (var no5 in contractNos) {
                  if (contractNos[no5].split(':')[0].indexOf('R') !== -1) {
                    newContractNos.push(contractNos[no5])
                  }
                }
                Emkt.setLocalStorage('newContractNos', null)
                Emkt.setLocalStorage('newContractNos', newContractNos)
//                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
//                  if (response.body.result.labelNames !== undefined) {
//                    Emkt.setLocalStorage('target', response.body.result.labelNames)
//                  }
//                })
              } else if (_this.attribute.value === '7') {
                newContractNos = []
                for (var no6 in contractNos) {
                  if (contractNos[no6].split(':')[0].indexOf('GOSL') !== -1 || (contractNos[no6].indexOf('慢病毒') !== -1 || contractNos[no6].indexOf('悬浮专用') !== -1 || contractNos[no6].indexOf('悬浮细胞专用') !== -1)) {
                    newContractNos.push(contractNos[no6])
                  }
                }
                Emkt.setLocalStorage('newContractNos', null)
                Emkt.setLocalStorage('newContractNos', newContractNos)
//                _this.gcapi('searchPreContract', 'GOSA66477').then(function (response) {
//                  if (response.body.result.labelNames !== undefined) {
//                    Emkt.setLocalStorage('target', response.body.result.labelNames)
//                  }
//                })
              } else {
                Emkt.setLocalStorage('newContractNos', contractNos)
              }
            }
          }
          if (_this.attribute.columnName === 'RequiredGoods' && _this.curAttrsInGroup[0].value === '4') {
            var newContractNos1 = []
            let contractNos1 = Emkt.getLocalStorage('contractNO')
            if (contractNos1) {
              if (_this.attribute.value === '3' || _this.attribute.value === '4' || _this.attribute.value === '5') {
                newContractNos1 = []
                for (var no3 in contractNos1) {
                  if (contractNos1[no3].split(':')[0].indexOf('GCEL') !== -1 || contractNos1[no3].split(':')[0].indexOf('GCZL') !== -1) {
                    newContractNos1.push(contractNos1[no3])
                  }
                }
                Emkt.setLocalStorage('newContractNos', null)
                Emkt.setLocalStorage('newContractNos', newContractNos1)
              }
            }
          }

          $.closeModal()
          if (_this.attribute.columnName === 'AAVBloodType') {
            if (Emkt.getLocalStorage('xueQingXing') !== null && Emkt.getLocalStorage('xueQingXing') !== undefined && _this.attribute.value !== undefined) {
              if (_this.attribute.value.toString() !== Emkt.getLocalStorage('xueQingXing').toString()) {
                $.modal({
                  title: '请核对',
                  afterText: '<div>订单选择的血清型与前合同' + _this.attribute.options[Emkt.getLocalStorage('xueQingXing')] + '不同，如果确定更换血清型，请点确认,否则请重新选择！</div>',
                  buttons: [
                    {
                      text: '重新选择',
                      bold: true,
                      onClick: function () {
                      }
                    },
                    {
                      text: '确认',
                      bold: true,
                      onClick: function () {
                        Emkt.setLocalStorage('xueQingXing', null)
                      }
                    }
                  ]
                })
              }
            }
          }
        })
      },
      valueChanged (attribute) {
        this.$emit('controlForm', this.index, this.curAttrsInGroup, attribute)
//        this.$emit('judgeValue', this.curAttrsInGroup, this.index)
      }
//      ,
//      getKeyByValue (value) {
//        let obj = this.attribute.options
//        for (var prop in obj) {
//          if (obj.hasOwnProperty(prop)) {
//            if (obj[prop] === value) {
//              return prop
//            }
//          }
//        }
//      }
    },
    watch: {
      'attribute.value': function (val) {
        this.attribute.valueText = this.attribute.options[val]
        if (!this.$route.query.cust) {
          this.$emit('controlForm', this.index, this.curAttrsInGroup, this.attribute)
        }
      }
//      ,
//      attribute: {
//        handler: function (val) {
//          this.attribute.value = this.getKeyByValue(val)
//        },
//        deep: true
//      }
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }
  .modal-class{
    width: 12rem;
    height: 15rem;
    margin-top: 1rem;
    margin-left: -3rem;
  }
</style>



// WEBPACK FOOTER //
// AttrEnumBox2.vue?50e1c51a